import {useTranslation} from "react-i18next";

const ListDetailsClient = ({ order }) => {
    const { t } = useTranslation()
    return (
        <div className="">
            <div className="max-w-7xl mx-auto px-2">
                <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-4">
                    <div className="px-4 py-2 sm:px-6">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            {t('Client details')}
                        </h3>
                    </div>

                    <div className="border-t border-gray-200">
                        <dl>
                            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium text-gray-500">
                                    {order.client.name}
                                </dt>
                                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                    {order.client.phone}
                                </dd>
                            </div>
                            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium text-gray-500">
                                    {t('Created at')}
                                </dt>
                                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                    {order.createdAt}
                                </dd>
                            </div>
                            {order.type != 'dinein' ?(
                                <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium text-gray-500">
                                        {t('Cutlery')}
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {order.cutlery_count}
                                    </dd>
                                </div>
                            ):null}
                            {order.type === 'dinein' ?(
                                <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                    <dt className="text-sm font-medium text-gray-500">
                                        {t('Table')}
                                    </dt>
                                    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {order.table_code}
                                    </dd>
                                </div>
                            ):null}
                            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                <dt className="text-sm font-medium text-gray-500">
                                    {t('Notes')}
                                </dt>
                                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                    {order.comment}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListDetailsClient
